import {useState, useEffect} from 'react';

interface windowSize {
  width: null | number;
  height: null | number;
}

export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState<windowSize>({
    width: null,
    height: null,
  });

  useEffect(() => {
    // Handler to call on window resize

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }


    window.addEventListener('resize', handleResize);

    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
